import { toDisplayString as _toDisplayString, toHandlers as _toHandlers, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_2 = { class: "dropdown" }
const _hoisted_3 = ["disabled", "id"]
const _hoisted_4 = ["aria-labelledby"]
const _hoisted_5 = ["disabled", "href"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-preview-pdf me-2" }, null, -1)
const _hoisted_7 = ["disabled"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-preview me-2" }, null, -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["disabled", "href"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-document-compare me-2" }, null, -1)
const _hoisted_12 = ["disabled", "href", "download"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-save me-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_popover = _resolveDirective("popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", _mergeProps({
        disabled: this.disabled,
        id: _ctx.$id('filebutton'),
        class: "btn btn-secondary dropdown-toggle",
        type: "button",
        "data-bs-toggle": "dropdown",
        "aria-expanded": "false",
        "data-bs-auto-close": "outside",
        ref: "dropdown"
      }, _toHandlers({ 'hide.bs.dropdown': () => _ctx.getPngPopover().hide(), })), _toDisplayString(_ctx.$t('general.file')), 17, _hoisted_3),
      _createElementVNode("ul", {
        class: "dropdown-menu",
        "aria-labelledby": _ctx.$id('filebutton')
      }, [
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            disabled: this.disabled,
            class: "dropdown-item",
            href: _ctx.pdfLink,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getDropdown().hide()))
          }, [
            _hoisted_6,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('review.review.header.pdfPreview')), 1)
          ], 8, _hoisted_5)
        ]),
        _createElementVNode("li", null, [
          _withDirectives(_createElementVNode("button", {
            disabled: this.disabled,
            class: "dropdown-item",
            type: "button",
            "data-bs-toggle": "popover",
            "data-bs-html": "true",
            "data-bs-custom-class": "reviewHeaderPngPreview",
            ref: "pngPopover"
          }, [
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('review.review.header.pngPreview')), 1)
          ], 8, _hoisted_7), [
            [_directive_popover, { content: () => _ctx.pngPopover }]
          ])
        ]),
        (_ctx.hasCmp)
          ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
              _createElementVNode("a", {
                disabled: this.disabled,
                class: "dropdown-item",
                href: _ctx.cmpLink,
                target: "_blank",
                onClick: [
                  _cache[1] || (_cache[1] = ($event: any) => (_ctx.getDropdown().hide())),
                  _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.openCmp()), ["prevent"]))
                ]
              }, [
                _hoisted_11,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('review.review.header.comparison')), 1)
              ], 8, _hoisted_10)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            disabled: this.disabled,
            class: "dropdown-item",
            href: _ctx.documentVersionLink,
            download: _ctx.documentVersionFileName,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getDropdown().hide()))
          }, [
            _hoisted_13,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('review.review.header.save')), 1)
          ], 8, _hoisted_12)
        ])
      ], 8, _hoisted_4)
    ])
  ]))
}